import { useQuery } from '@tanstack/react-query';
import { fetchAuditLogs, type AuditLogListParams } from '@/api/audit';

export function useAuditLogs(params?: AuditLogListParams) {
  return useQuery({
    queryKey: ['audit-logs', params],
    queryFn: () => fetchAuditLogs(params),
    staleTime: 15 * 1000,
  });
}
